import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthorizedEntities } from "../../actions/lp";
import { getAuthorizedEntitiesSelector, getAuthorizedLpSelectedSelector } from "../../actions/lp/selectors";
import { ENTITY_FILTER_ENUMS } from "../../constants/authorization";
export function useAuthorizedEntities() {
    var dispatch = useDispatch();
    var lpSelected = useSelector(getAuthorizedLpSelectedSelector);
    var authorizedEntities = useSelector(getAuthorizedEntitiesSelector);
    useEffect(function() {
        var _lpSelected;
        if (isEmpty(lpSelected) || isEmpty((_lpSelected = lpSelected) === null || _lpSelected === void 0 ? void 0 : _lpSelected.lpId)) return;
        dispatch(getAuthorizedEntities.request({
            entityFilter: ENTITY_FILTER_ENUMS.NO_FILTER
        })); // To Fetch All authorized Entities
    }, [
        dispatch,
        lpSelected
    ]);
    return authorizedEntities;
}

//# sourceMappingURL=useAuthorizedEntities.js.map